import { render, staticRenderFns } from "./EmbeddedDesigner.vue?vue&type=template&id=9540e370&scoped=true"
import script from "./EmbeddedDesigner.vue?vue&type=script&lang=js"
export * from "./EmbeddedDesigner.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedDesigner.vue?vue&type=style&index=0&id=9540e370&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9540e370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9540e370')) {
      api.createRecord('9540e370', component.options)
    } else {
      api.reload('9540e370', component.options)
    }
    module.hot.accept("./EmbeddedDesigner.vue?vue&type=template&id=9540e370&scoped=true", function () {
      api.rerender('9540e370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/print-template/EmbeddedDesigner.vue"
export default component.exports